<form class="fullscreen-dialog" [formGroup]="form">

    <div class="sticky-header">
        <h2 class="!flex !items-center" mat-dialog-title>
            <mat-icon class="pointer" (click)="close.emit()">keyboard_arrow_left</mat-icon>

            <ng-container *ngIf="!itemToBeUpdated">
                New location (IP ranges)
            </ng-container>

            <ng-container *ngIf="itemToBeUpdated">
                Update location (IP ranges)


                <button mat-button [matMenuTriggerFor]="menu">
                    <mat-icon color="warn">
                        delete
                    </mat-icon>
                </button>

                <mat-menu #menu="matMenu">
                    <div class="p-4 ">
                        Deleting this named location is a permanent action and cannot be undone.
                    </div>

                    <div class="p-4 flex items-center gap-2">

                        <button mat-raised-button color="warn" (click)="delete()">
                            Delete
                        </button>

                        <button class="mx-2" mat-raised-button>
                            Cancel
                        </button>
                    </div>
                </mat-menu>
            </ng-container>
        </h2>



        <div class="block">
            <mat-label>Name</mat-label>
            <input [class.border-red-500]="form.get('displayName').invalid && form.get('displayName').touched"
                placeholder="Name this location" class="simple-input" formControlName="displayName" />

            <mat-error *ngIf="form.get('displayName').invalid && form.get('displayName').touched" class="">
                <span>Name is required</span>
            </mat-error>
        </div>
    </div>

    <div class="ips content">
        <div class="mv-4">
            <mat-checkbox formControlName="isTrusted">
                Mark as trusted location
            </mat-checkbox>
        </div>

        <div *ngIf="!showInput" class="pointer mv-4">
            <mat-icon color="primary" size="large" (click)="showInput = true">add</mat-icon>
        </div>

        <div *ngIf="showInput" class="block">
            <mat-label>Enter a new IPv4 or IPv6 range</mat-label>
            <input [class.border-red-500]="form.get('cidrAddress').invalid && form.get('cidrAddress').dirty"
                placeholder="ex: 40.77.182.32/27 or 2a01:111::/32" class="simple-input" formControlName="cidrAddress" />

            <mat-error *ngIf="form.get('cidrAddress').invalid && form.get('cidrAddress').dirty" class="">
                <span>{{form.get('cidrAddress').getError('ipCidr')}}</span>
            </mat-error>


            <div class="actions flex gap-2">
                <button mat-button (click)="addIp()" [disabled]="form.get('cidrAddress').invalid"
                    color="primary">Add</button>
                <button mat-button (click)="showInput = false" class="cancel-btn">Cancel</button>
            </div>
        </div>


        <div *ngIf="ipRanges.length > 0" class="ips">
            <h3 class="mb-2"> {{ipRanges.length}} IP ranges found</h3>

            <mat-list>
                <mat-list-item *ngFor="let ip of ipRanges; let i = index">
                    <div class="flex justify-between items-center w-3/4 border-b border-gray-300">
                        <span>{{ ip }}</span>
                        <button mat-icon-button color="warn" (click)="ipRanges.splice(i, 1)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </mat-list-item>
            </mat-list>
        </div>

    </div>

    <div class="dialog-footer">
        <button [class.loading-btn]="isCreating" [disabled]="form.get('displayName').invalid || ipRanges.length === 0"
            (click)="save()" mat-raised-button color="primary">
            Save
        </button>

        <button (click)="close.emit()" mat-raised-button type="button">
            Cancel
        </button>
    </div>
</form>
